import React from 'react'
// import Helmet from 'react-helmet'
// import Page from '../components/Page'
import styled from 'styled-components'

let ImageXS = './images/drafting-320.jpg';
let ImageS = './images/drafting-640.jpg';
let ImageM = './images/drafting-1024.jpg';
let ImageL = './images/drafting-1280.jpg';

let PImageXS = './images/property-measuring-640.jpg';
let SImageXS = './images/wr/A2-WALLREBAR-SITE-640.jpg';
let RImageXS = './images/rendering-640.png';
let ADUImage = './images/ADU_800.png';

let MainPhoto = styled.img`
    width: 100%;
    max-height: 525px;
`;

export default () => (
    <div style={{maxWidth: '100%'}}>
        <div className="row" style={{margin: 0}}>
                <div className="col-12" style={{padding: 0}}>
                    <MainPhoto alt='design plans' srcSet={
                            `${ImageXS} 320w,
                            ${ImageS} 640w,
                            ${ImageM} 1024w,
                            ${ImageL} 1280w`} sizes={"(max-width: 420px) 320px, (max-width: 740px) 640px, (max-width: 1124px) 1024px, 1280px"}/>
                </div>
        </div>
        <div className="p-5">
            <div className="row">
                <div className="col-12 text-center">
                    <h3>Calmel Drafting & Designs</h3>
                    <p className="lead">CalMel provides drafting &amp; designs for both new and existing projects,
                    including “As-built Drawings”. CalMel uses advanced programming to provide descriptive drafting/designs
                    in our remodeling and expansion projects to help assist both our client and consultants. We take measurements
                    of residential houses, apartments, and any kind of commercial buildings. We present quick and accurate measuring
                    services. We measure buildings of any kind with a high level of accuracy very close tolerance levels. CalMel has 10 years of
                    experience in drafting, and field measuring providing excellent services.</p>
                </div>
            </div>
            <div className="row d-flex justify-content-around pt-5">
                <div className="col-12 col-sm-4 card p-0 mb-5 mb-sm-0 h-75">
                    <img className="card-img-top" src={ADUImage} alt="accessory dwelling unit" />
                    <div className="card-body">
                      <h5 className="card-title">Accessory Dwelling Unit (ADU)</h5>
                      <p className="card-text">With high demands for affordable housing, and limited availability in the Greater Los Angeles area
                      and other counties. CalMel has been able to assist it's clients with blueprints/plans to expand their properties by converting
                      their garages or adding new ground-up dwellings providing more living space and adding value to their homes. CalMel provides 
                      unique and custom designs for ADU's that work best with existing property conditions to help the development of its clients.
                      Custom designs can have their own kitchen, living area, bathroom, as well as it's own private entrance. Separate utility
                      lines to service the ADU is also an option. 
                      </p>
                    </div>
                </div>
                <div className="col-12 col-sm-4 card p-0 mb-5 mb-sm-0">
                    <img className="card-img-top" src={PImageXS} alt="property measuring" />
                    <div className="card-body">
                      <h5 className="card-title">Property Measuring</h5>
                      <p className="card-text">Field measuring for existing structures as well as new construction to be developed.</p>
                    </div>
                </div>
            </div>
            <div className="row d-flex justify-content-around pt-5">
                <div className="col-12 col-sm-4 card p-0 mb-5 mb-sm-0 h-75">
                    <img className="card-img-top" src={SImageXS} alt="shop drawing" />
                    <div className="card-body">
                      <h5 className="card-title">Shop Drawings</h5>
                      <p className="card-text">CalMel also provides construction shop drawings for all types of custom work such as; Rebar,
                      Architectural Concrete, Steel, &amp; Landscape Layout for project submitting.</p>
                    </div>
                </div>
                <div className="col-12 col-sm-4 card p-0 mb-5 mb-sm-0">
                    <img className="card-img-top" src={RImageXS} alt="3D rendered" />
                    <div className="card-body">
                      <h5 className="card-title">3D Rendering</h5>
                      <p className="card-text">CalMel also provides 3D rendering for all types of projects. By providing 3D rendering to a floor plan you
                      can take our clients ideas and our creativity and merge them for the final result, a stunning image that
                      will ensure the success of your project. The realism in our 3D renderings has contributed to our growth
                      with both new and existing projects.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/views/Home.js